import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { Company } from '../../../models/company.model';
import { AccountingAccount } from '../../../models/accounting.account.model';
import { Contact } from '../../../models/contact.model';
import { Settings } from '../../../models/settings.model';
import { TreasuryAccount } from '../../../models/treasury.account.model';

export interface AccountingPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  settingsForCompany: Settings | null,
  accountingAccountsForCompany: AccountingAccount[] | null,
  contactsForCompany: Contact[] | null,
  treasuryAccountsForCompany: TreasuryAccount[] | null
};

const AccountingPage: React.FunctionComponent<AccountingPageProps> = props => {
  const {setRoute, companyForUser, settingsForCompany, accountingAccountsForCompany, contactsForCompany, treasuryAccountsForCompany} = UseOutletContext()

  return (
    <Outlet context={{setRoute, companyForUser, settingsForCompany, accountingAccountsForCompany, contactsForCompany, treasuryAccountsForCompany}}></Outlet>
  );
}

export function UseOutletContextAccounting() {
  return useOutletContext<ContexType>()
};

export default AccountingPage;
